import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { FaCheckCircle } from "react-icons/fa";

const SuccessPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Order has been placed successfully | BP11 Art Prints";
  }, []);
  const { t } = useTranslation();

  return (
    <Container>
      <FaCheckCircle className="icon" />
      <h1>{t("scOrder1")}</h1>
      <h2>{t("scOrder2")}</h2>
      <p>{t("scOrder3")}</p>
      <Link to={"/produktet"}>
        <button>{t("scOrderBtn")}</button>
      </Link>
    </Container>
  );
};
const Container = styled.div`
  padding: 7em 5%;
  text-align: center;
  background-color: var(--primaryBackgroundColor);
  color: var(--fontPrimaryColor);
  .icon {
    font-size: 12em;
    color: #1c7e1c;
  }
  h1 {
    font-family: "Comfortaa", sans-serif;
    font-size: 5em;
    font-weight: 200;
  }
  h2 {
    margin: 1em;
    font-weight: 500;
  }
  p {
    color: #cacaca;
  }
  button {
    margin: auto;
    font-family: "Poppins", sans-serif;
    font-size: 18px;
    background: white;
    color: #777777;
    border: none;
    padding: 15px 24px;
    transition: 0.4s;
    margin: 1em;
    border: 1px solid #c7c7c7;
    cursor: pointer;
    &:hover {
      background: var(--primaryColor);
      color: white;
    }
  }
  @media (max-width: 650px) {
    h1 {
      font-size: 11vw;
    }
  }
`;

export default SuccessPage;
